let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("flujA")).then(() => parcelRequire('11DQh'));